
import { required, email } from "vuelidate/lib/validators";
import { apiCreateLead } from "~/services/lead";
import handleToken from "@/mixins/handleToken";
import OurPartners from "./OurPartners.vue";
import {
    DATE_PLACES,
    TIME_SLOTS,
    EVENT_MONTH,
    PROJECT_INFO,
} from "~/constants";

export default {
    components: { OurPartners },
    mixins: [handleToken],
    props: {
        step: {
            type: Number,
            default: 1,
        },
        selectedDate: {
            type: String,
            default: null,
        },
        selectedPlace: {
            type: String,
            default: null,
        },
        datePlaces: {
            type: Array,
            default: () => DATE_PLACES,
        },
        eventMonth: {
            type: String,
            default: EVENT_MONTH,
        },
        timeSlots: {
            type: Array,
            default: () => TIME_SLOTS,
        },
        projectInfo: {
            type: Object,
            default: () => PROJECT_INFO,
        },
    },
    data() {
        return {
            activeStep: 1,
            dateEvent: this.selectedDate,
            placeEvent: this.selectedPlace,
            lead: {
                date: this.selectedDate,
                name: null,
                phone: null,
                email: null,
                selectedTime: null,
                comments: null,
            },
        };
    },
    computed: {
        loading() {
            return this.$store.state.loading;
        },
        getTimes() {
            return this.timeSlots;
        },
    },
    validations() {
        return {
            lead: {
                name: { required },
                phone: { required },
                email: { required, email },
            },
        };
    },
    watch: {
        step(newStep) {
            this.activeStep = newStep;
        },
        selectedDate(newDate) {
            if (newDate) {
                this.lead.date = newDate;
            }
        },
        selectedPlace(newPlace) {
            if (newPlace) {
                this.placeEvent = newPlace;
            }
        },
        async "$route.query.utm_source"() {
            await this.createLead();
        },
    },
    methods: {
        resetLead() {
            this.lead.selectedTime = null;
            this.lead.name = null;
            this.lead.email = null;
            this.lead.phone = null;
            this.lead.date = null;
            this.lead.comments = null;
            this.placeEvent = null;
            this.activeStep = 1;
        },
        resetActiveStep() {
            this.activeStep = 1;
            this.$emit("updateStep", {
                step: 1,
                selectedDate: null,
                selectedPlace: null,
            });
        },
        proceedToNextStep() {
            this.activeStep = 2;
        },
        proceedToForm() {
            if (this.lead.selectedTime) {
                this.activeStep = 4;
            }
        },
        submitForm() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.activeStep = 4;
            }
        },
        selectPlace(date, place) {
            const dayOfdate = date.split("/")[2];
            this.lead.date = date;
            this.activeStep = 3;
            this.dateEvent = dayOfdate;
            this.placeEvent = place;            
        },
        updateLeadComment() {
            this.lead.comments = `Taiwan Roadshow, ${this.lead.date} ${this.lead.selectedTime}`;
        },
        async createLead() {
            this.$v.$touch();
            if (!this.$v.lead.$error) {
                if (!this.$route.query.utm_source) {
                    if (this.getToken()) {
                        await this.$router.push({
                            query: { ...this.$route.query, ...this.getToken() },
                        });
                    } else {
                        await this.$router.push({
                            query: {
                                ...this.$route.query,
                                utm_source: "organic",
                            },
                        });
                    }
                } else {
                    this.$store.commit("startLoading");
                    this.updateLeadComment();
                    const response = await apiCreateLead(this.lead);
                    this.$gtm.push({ event: "signUpCompleted" });
                    const data = {
                        ...this.lead,
                        ...this.getToken(),
                        fullUrl: window.location.href.split("?")[0],
                    };

                    if (response) {
                        this.$v.lead.name.$model = null;
                        this.$v.lead.email.$model = null;
                        this.$v.lead.phone.$model = null;
                        this.$nextTick(() => {
                            this.$v.$reset();
                        });
                        this.activeStep = 5;
                    }

                    this.$store.commit("endLoading");

                    try {
                        await this.$axios({
                            method: "post",
                            url: "postback",
                            baseURL: "/",
                            data,
                        });
                    } catch (err) {}
                }
            } else if (!this.lead.phone && this.activeStep === 1) {
                this.activeStep = 2;
            } else {
                this.resetActiveStep();
            }
        },
    },
};
